import PropTypes from "prop-types";

import { Title, Content } from "./styles";

const Description = ({ title, children }) => {
  return (
    <div>
      <Title variant="h1" color="primary" component="h3" align="center">
        {title}
      </Title>
      <Content>{children}</Content>
    </div>
  );
};

Description.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Description;
